import { render, staticRenderFns } from "./DoorsSection.vue?vue&type=template&id=05d8217d&"
import script from "./DoorsSection.vue?vue&type=script&lang=js&"
export * from "./DoorsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports